import * as React from "react";
import { StandardProps } from "@material-ui/core";
import MuiListItemIcon, { ListItemIconClassKey as MuiListItemIconClassKey } from "@material-ui/core/ListItemIcon";


export type ListItemIconClassKey = MuiListItemIconClassKey;

export interface ListItemIconProps
    extends StandardProps<React.HTMLAttributes<HTMLDivElement>, ListItemIconClassKey> {
    children: React.ReactElement<any>;
}


class ListItemIcon extends React.PureComponent<ListItemIconProps> {
    render() {
        const { ...props } = this.props;
        return <MuiListItemIcon {...props}>
            {this.props.children}
        </MuiListItemIcon>;
    }
}

export default ListItemIcon;